export var ESTIMATE_BASIC_INFO;
(function (ESTIMATE_BASIC_INFO) {
    // estimateDefaultInfo
    ESTIMATE_BASIC_INFO["\uBC1C\uD589\uC77C"] = "\uBC1C\uD589\uC77C";
    ESTIMATE_BASIC_INFO["\uC0AC\uB0B4\uACAC\uC801\uBC88\uD638"] = "\uC0AC\uB0B4 \uACAC\uC801\uBC88\uD638";
    ESTIMATE_BASIC_INFO["\uAE30\uC5C5\uBCC4\uC785\uCC30\uBC88\uD638"] = "\uAE30\uC5C5\uBCC4 \uC785\uCC30\uBC88\uD638";
    // estimateDefaultInfo2
    ESTIMATE_BASIC_INFO["\uB0A9\uAE30\uC77C"] = "\uB0A9\uAE30\uC77C";
    ESTIMATE_BASIC_INFO["\uACAC\uC801\uBA85"] = "\uACAC\uC801\uBA85";
    ESTIMATE_BASIC_INFO["\uACAC\uC801\uAE30\uAC04"] = "\uACAC\uC801 \uAE30\uAC04";
    ESTIMATE_BASIC_INFO["\uD2B9\uC774\uC0AC\uD56D"] = "\uD2B9\uC774\uC0AC\uD56D";
    // _estimateSearchCompanyInfoInputs
    ESTIMATE_BASIC_INFO["\uC5C5\uCCB4\uBA85"] = "\uC5C5\uCCB4\uBA85";
    ESTIMATE_BASIC_INFO["\uB2F4\uB2F9\uC790"] = "\uB2F4\uB2F9\uC790";
    ESTIMATE_BASIC_INFO["\uB2F4\uB2F9\uC790\uC774\uBA54\uC77C"] = "\uB2F4\uB2F9\uC790 E-mail";
    ESTIMATE_BASIC_INFO["\uB2F4\uB2F9\uC790\uC5F0\uB77D\uCC98"] = "\uB2F4\uB2F9\uC790 \uC5F0\uB77D\uCC98";
    // _estimateFilesInputs
    ESTIMATE_BASIC_INFO["\uC2B9\uC778\uC11C"] = "\uC2B9\uC778\uC11C";
    ESTIMATE_BASIC_INFO["\uB3C4\uBA74"] = "\uB3C4\uBA74";
    ESTIMATE_BASIC_INFO["\uAE30\uD0C0"] = "\uAE30\uD0C0";
})(ESTIMATE_BASIC_INFO || (ESTIMATE_BASIC_INFO = {}));
